import { useCallback } from 'react'

import { logError } from '@core/logging'

import { useSocketContext } from './SocketContext'

/**
 * Disconnects the socket if the socket is open
 */
export const useDisconnectOpenSocket = () => {
  const { socket } = useSocketContext()

  const disconnectOpenSocket = useCallback(() => {
    if (!socket) {
      logError(new Error('Socket is not available'))
    }

    if (socket?.connectionState() === 'open') {
      socket.disconnect()
    }
  }, [socket])

  return disconnectOpenSocket
}
